// Scroll an opened schedule game card so it sits exactly under whatever is frozen
// at the top (site header, week bar, that day's date header) — measured live, so
// it lands right on every Display setting (compact, scale, nav styles…).
const docTop = (node) => { let t = 0; while (node) { t += node.offsetTop || 0; node = node.offsetParent; } return t; };
const cssNum = (v, d) => parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(v), 10) || d;

// Bottom of the contiguous stack of stuck sticky/fixed bars starting at the top edge.
const stickyBottom = (card) => {
    const rects = [];
    document.querySelectorAll('header,[data-nhl-weekbar],[data-nhl-dayhdr],[class*="sticky"],[class*="fixed"]').forEach((n) => {
        if (n.contains(card) || card.contains(n)) return;
        const pos = window.getComputedStyle(n).position;
        if (pos !== "sticky" && pos !== "fixed") return;
        const r = n.getBoundingClientRect();
        if (r.height < 8 || r.height > 400 || r.width < 200 || r.top < -1 || r.top > window.innerHeight * 0.5) return;
        rects.push(r);
    });
    rects.sort((a, z) => a.top - z.top);
    let b = 0;
    for (const r of rects) if (r.top <= b + 4) b = Math.max(b, r.bottom);
    return b;
};

// Keeps correcting for ~2s while the panel's content loads (the page is often too short
// to scroll the card up until it does — the old one-shot pin needed re-taps). Stops the
// moment the user scrolls/touches. Returns a cancel function.
export function pinScheduleCard(card, { desktop, mobileOffset = 8, gap = 8 }) {
    if (!card) return () => {};
    let stop = false, n = 0, timer = 0;
    const target = () => (desktop ? stickyBottom(card) + gap : mobileOffset);
    const evs = ["wheel", "touchstart", "keydown"];
    const cancel = () => { stop = true; clearTimeout(timer); evs.forEach((e) => window.removeEventListener(e, cancel, true)); };
    evs.forEach((e) => window.addEventListener(e, cancel, { passive: true, capture: true }));
    window.scrollTo(0, Math.max(0, docTop(card) - (desktop ? cssNum("--nhl-hdr-bottom", 180) + cssNum("--nhl-weekbar-h", 58) + 48 : mobileOffset)));
    const loop = () => {
        if (stop || !card.isConnected) return cancel();
        const delta = card.getBoundingClientRect().top - target();
        if (Math.abs(delta) > 1) window.scrollBy(0, delta);
        if (++n < 40) timer = setTimeout(loop, 50); else cancel();
    };
    requestAnimationFrame(loop);
    return cancel;
}
